import { Map } from 'immutable';
import { FREEZE_CASH_IN_PRICE } from './actions';

export const initialState = new Map({
  requestIsPending: false,
  price: null,
  betDelay: null
});

export default (state = initialState, action) => {
  switch (action.type) {
    case FREEZE_CASH_IN_PRICE: {
      return state.set('price', action.price);
    }
    default: {
      return state;
    }
  }
};
